import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const ClientDisconnectedHelpIcon: FC<{ ended_at: string }> = ({ ended_at }) => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" className={classes.title}>
            Client Disconnected{" "}
            {ended_at && `on ${new Date(ended_at).toLocaleDateString()}`}
          </Typography>
          <Typography variant="body1" className={classes.text}>
            This client disconnected from you. Data uploaded prior to
            disconnecting will remain available. Any content scheduled for after
            the disconnection will not be sent. To access new data or send new
            content after disconnecting, reconnect with this client.
          </Typography>
        </>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default ClientDisconnectedHelpIcon
